<script>
import Layout from '../../layouts/main'
import Toast from '../../../components/toast.vue'
import DishPreview from './dishPreview.vue'
import { apiService } from '@/helpers/api.service';
import UploadImage from '../../../components/uploadImage.vue'
import { permissionsMap, checkPermission } from '@/utils/utilsPermissions';
import PermissionTooltip from '../../../components/permission-tooltip.vue';
import VeggieIcon from '@/assets/icons/veggie.svg';
import VeganIcon from '@/assets/icons/vegan.svg';
import KetoIcon from '@/assets/icons/keto.svg';
import GlutenFreeIcon from '@/assets/icons/glutenfree.svg';


export default {
    components: { 
        Layout, 
        Toast, 
        DishPreview, 
        UploadImage, 
        PermissionTooltip,
        VeggieIcon,
        VeganIcon,
        KetoIcon,
        GlutenFreeIcon,
     },
    props: {},
    data() {
        return {
            discounts: [5, 10, 15, 20, 25, 50],
            selectedDiscount: null,
            veggie: false,
            vegan: false,
            healthy: false,
            glutenFree: false,
            isCeliac: false,
            name: '',
            description: '',
            price: '',
            type: [],
            urlImage: '',
            isSubmitted: false,
            file: '',
            url: '',
            placeholderImg: true,
            imgSrc: '',
            errorImage: false,
            dishId: null,
            dish: null,
            isSuccessDish: false,
            isErrorDish: false,
            isActive: true,
            categories: [],
            selectedCategories: [],
            newCategory: '',
            isNewCategory: false,
            showEraseButtonC: null,
            flavours: [],
            newFlavour: '',
            newFlavourIsVisible: true,
            isNewFlavour: false,
            showEraseButtonF: null,
            flavourAmount: 1,
            flavourMinQuantity: 1,
            addons: [],
            newAddon: '',
            isNewAddon: false,
            showImageTooltipImage: false,
            showDiscountTooltip: false,
            showPriceTooltipPrice: false,
            newAddonPrice: '',
            showEraseButtonA: null,
            store: null,
            editedCategories: [],
            personalizedDiscount: null,
            categoryToDelete: null,
            isMobile: false,
        };
    },
    mounted() {
        this.dishId = this.$route.params.id
        if (this.dishId) this.getDish()
        this.getCategories()
        this.canChangePrice()
        this.canEditDish()
        this.canChangeCategory()
        this.canDiscountDish()
        this.canFlavor()
        this.canAddon()
        this.canImage()
    },
    watch: {
        categories: {
            handler() {
                this.editedCategories = this.categories.map(({ name }) => this.formatCategoryName(name));
            },
            deep: true
        },
        isMobile() {
            return window.innerWidth < 768;
        }
    },
    computed: {
        filteredFlavours() {
            return this.flavours.filter(flavour => flavour.name != '');
        }
    },
    methods: {
        handleMouseLeave() {
            // This method is intentionally left empty to prevent the mouseout behavior
            // The mouseleave event is already handled by the parent element
        },
        formatPriceInput() {
            let value = this.price;
            if (typeof value === 'string') {
                value = value.replace(',', '.');
            }
            const match = value.toString().match(/^\d*(\.\d{0,2})?/);
            if (match) {
                this.price = match[0];
            }
        },
        canChangePrice() {
            if (this.dishId) {
                return checkPermission(permissionsMap.UPDATE_OWN_STORE_PRODUCT_PRICE, this.$store.state.permissions)
            }
            return true
        },
        canDeleteCategory() {
            return checkPermission(permissionsMap.DELETE_OWN_STORE_CATEGORY, this.$store.state.permissions)
        },
        canFlavor() {
            return checkPermission(permissionsMap.UPDATE_OWN_STORE_PRODUCT_FLAVOR, this.$store.state.permissions)
        },
        canAddon() {
            return checkPermission(permissionsMap.UPDATE_OWN_STORE_PRODUCT_EXTRA, this.$store.state.permissions)
        },
        canEditDish() {
            return checkPermission(permissionsMap.UPDATE_OWN_STORE_PRODUCT, this.$store.state.permissions)
        },
        canChangeCategory() {
            return checkPermission(permissionsMap.UPDATE_OWN_STORE_PRODUCT_CATEGORY, this.$store.state.permissions)
        },
        canUpdateCategory() {
            return checkPermission(permissionsMap.UPDATE_OWN_STORE_CATEGORY, this.$store.state.permissions)
        },
        canDiscountDish() {
            if (this.dishId) {
                return checkPermission(permissionsMap.UPDATE_OWN_STORE_PRODUCT_DISCOUNT, this.$store.state.permissions)
            }
            return true
        },
        canImage() {
            return checkPermission(permissionsMap.UPDATE_OWN_STORE_PRODUCT_IMAGE, this.$store.state.permissions)
        },
        getDish() {
            apiService.getDishById(this.dishId).then((dish) => {
                this.name = dish.name
                this.description = dish.description
                this.price = dish.unitPrice
                this.isActive = dish.isActive
                this.isCeliac = dish.isCeliac
                const type = dish.type


                if (type.indexOf('Gluten free') != -1) this.glutenFree = true
                if (type.indexOf('Vegan') != -1) this.vegan = true
                if (type.indexOf('Healthy') != -1) this.healthy = true
                if (type.indexOf('Vegetarian') != -1) this.veggie = true
                if ( dish.discount?.amount) {
                    this.selectedDiscount = (dish.discount.amount * 100).toFixed(2)

                    this.selectedDiscount = this.selectedDiscount.endsWith('.00') ? Number(this.selectedDiscount) : this.selectedDiscount;
                    if (!this.discounts.includes(this.selectedDiscount)) {
                        this.personalizedDiscount = this.selectedDiscount;
                    }

                } else {
                    this.selectedDiscount = null
                }

                if (dish.urlImage) {
                    this.placeholderImg = false
                    this.imgSrc = dish.urlImage
                }

                if (dish.categories) {
                    this.selectedCategories = dish.categories.map(oldCat => {
                        const matchingCat = this.categories.find(newCat => newCat._id === oldCat._id);
                        return matchingCat ? { ...oldCat, name: matchingCat.name } : oldCat;
                    });
                }

                if (dish.addon.length != 0) {
                    this.addons = dish.addon[0].options.map(option => ({
                        name: option.name,
                        price: option.price
                    }));
                }
                if (dish.personalize.length != 0) {
                    this.flavourAmount = dish.personalize[0].maxQuantity
                    this.flavourMinQuantity = dish.personalize[0].minQuantity || 1
                    this.flavours = dish.personalize[0].options.map(option => ({ id: option._id, name: option.name, isVisible: option.isVisible}));
                }
            })
        },
        onFileChange(file) {
            const imgSize = this.checkImgSize(file)
            if (imgSize == false) return
            this.placeholderImg = false
            this.file = file
            this.url = URL.createObjectURL(this.file);
            let self = this
            fetch(this.url)
                .then((response) => {
                    response.blob().then(blobResponse => {
                        let reader = new FileReader();
                        reader.readAsDataURL(blobResponse);
                        reader.onloadend = function () {
                            let base64data = reader.result;
                            self.imgSrc = base64data
                        }
                    })
                })
        },
        checkImgSize(file) {
            const inputSize = file.size
            const maxSize = 10000000
            if (inputSize > maxSize) {
                this.errorImage = true
                return false
            }
        },
        checkValidators() {
            const isType = (this.vegan || this.glutenFree || this.veggie || this.healthy) ? true : false
            const validator = (this.name && this.price && this.description && isType) ? true : false
            return validator
        },
        createDishObject() {
            this.type = []
            if (this.veggie) this.type.push('Vegetarian')
            if (this.vegan) this.type.push('Vegan')
            if (this.healthy) this.type.push('Healthy')
            if (this.glutenFree) this.type.push('Gluten free')

            this.dish = {
                name: this.name,
                description: this.description,
                unitPrice: Number(parseFloat(this.price).toFixed(2)),
                type: this.type,
                urlImage: this.imgSrc,
                isActive: this.isActive,
                isCeliac: this.isCeliac
            }

                const discountValue = Number(this.selectedDiscount);
                this.dish.price = Number((parseFloat(this.price) * (100 - discountValue) / 100).toFixed(2));
                this.dish.discount = {
                    type: "Percentage",
                    amount: discountValue / 100,
                    label: `${discountValue}%`
                };
                
            if (this.file) this.dish.file = this.file
            if (this.dishId) this.dish.dishId = this.dishId
            if (this.selectedCategories.length != 0) {
                this.selectedCategories = this.selectedCategories.filter(sc => sc.name !== 'OTHERS');
                this.dish.categories = this.selectedCategories
            } else {
                const othersCategory = this.categories.find(obj => obj.name === "OTHERS")
                this.dish.categories = othersCategory ? [othersCategory] : null
            }
            if (this.flavours.length != 0) {
                let options = []
                for (const flavour of this.flavours) {
                    if (!flavour.name || flavour.name.trim() === '') {
                        continue;
                    }
                    const option = {
                        "name": `${flavour.name}`,
                        "isVisible": flavour.isVisible
                    }
                    options = [option, ...options]
                }
                const hasActiveOptions = options.some(option => option.isVisible !== false)
                this.dish.personalize = [
                    {
                        "name": "Agrega a tu producto",
                        "minQuantity": hasActiveOptions ? this.flavourMinQuantity : 0,
                        "maxQuantity": this.flavourAmount,
                        "options": options
                    }
                ]
            }
            if (this.addons.length != 0) {
                const formatedAddons = this.addons.map(addon => ({
                    ...addon,
                    price: parseFloat(addon.price)
                }));
                this.dish.addon = [
                    {
                        "name": "EXTRA",
                        "options": formatedAddons
                    }
                ]
            }
        },
        showDishToast(value) {
            if (value) {
                this.isSuccessDish = true
            } else {
                this.isErrorDish = true
            }
        },
        goToDishes() {
            this.$router.push('/welly/my-dishes')
            this.isSuccessDish = false
        },
        getCategories() {
            let user = JSON.parse(localStorage.getItem('user')).data.user
            this.store = localStorage.getItem('store') != "undefined" ? JSON.parse(localStorage.getItem('store')) : {"name": user.name, "isOpen": false}
            const storeCat = this.store.categories
            this.categories = storeCat.map(({ name, _id }) => ({ name, _id }));
            this.sortItems(this.categories)
        },
        isCategorySelected(category) {
            const categoryFound = this.selectedCategories.find(cat => cat._id === category._id)
            if (categoryFound) return true
            return false
        },
        toggleSelectedCategory(category) {
            if (this.isCategorySelected(category)) {
                const index = this.selectedCategories.findIndex(cat => cat._id === category._id);
                if (index !== -1) {
                    this.selectedCategories.splice(index, 1);
                }
            } else {
                this.selectedCategories.push(category)
            }
        },
        addNewCategory() {
            this.isNewCategory = true;
            this.$nextTick(() => {
                this.$refs.inputFieldCategory.focus();
            });
        },
        handleNewCategory() {
            if (this.newCategory != '') {
                const newCategoryObject = { name: this.newCategory.toUpperCase() }
                const foundCategory = this.categories.find(e => e == newCategoryObject);
                if (foundCategory != -1) {
                    apiService.postCategory(newCategoryObject)
                        .then((res) => {
                            localStorage.setItem('store', JSON.stringify(res.data))
                            this.categories = res.data.categories
                            for (const category of this.categories) {
                                if (category.name == this.newCategory.toUpperCase()) {
                                    this.selectedCategories.push(category)
                                }
                            }
                            this.newCategory = ''
                        })
                        .finally(() => {
                            this.isNewCategory = false
                            this.sortItems(this.categories)
                        }
                        )
                } else {
                    this.newCategory = ''
                    this.isNewCategory = false
                }
            } else {
                this.isNewCategory = false
            }

        },
        eraseCategory(category) {
            const indexSelected = this.selectedCategories.findIndex(cat => cat._id === category._id);
            if (indexSelected !== -1) {
                this.selectedCategories.splice(indexSelected, 1);
            }
            const index = this.categories.findIndex(cat => cat._id === category._id);
            if (index !== -1) {
                this.categories.splice(index, 1);
            }
            apiService.deleteCategorybyId(category._id)
                .then(() => {
                    const index = this.store.categories.findIndex(cat => cat._id === category._id);
                    if (index !== -1) {
                        this.store.categories.splice(index, 1);
                    }
                    localStorage.setItem('store', JSON.stringify(this.store))
                })
        },
        editCategory(category, newName) {
            const indexSelected = this.selectedCategories.findIndex(cat => cat._id === category._id);
            indexSelected !== -1 && (this.selectedCategories[indexSelected].name = newName.toUpperCase());
            const index = this.categories.findIndex(cat => cat._id === category._id);
            index !== -1 && (this.categories[index].name = newName.toUpperCase());


            apiService.editCategorybyId(category._id, { "name": newName })
                .then((res) => {
                    localStorage.setItem('store', JSON.stringify(res))
                })
            this.sortItems(this.categories)
        },
        checkEditedCategories() {
            this.categories.forEach((category, index) => {
                if (category.name.toLowerCase() !== this.editedCategories[index].toLowerCase()) {
                    this.editCategory(category, this.editedCategories[index]);
                }
            });
        },
        addNewFlavour() {
            // Si hay un input activo con texto, primero guardarlo
            if (this.isNewFlavour && this.newFlavour && this.newFlavour.trim() !== '') {
                this.flavours.push({
                    name: this.newFlavour.trim(),
                    isVisible: true,
                });
                this.newFlavour = '';
                this.newFlavourIsVisible = true;
            }
            
            // Mostrar nuevo input
            if (!this.isNewFlavour) {
                this.isNewFlavour = true;
                this.$nextTick(() => {
                    this.$refs.inputFieldFlavour.focus();
                });
            }
        },
        handleNewFlavour() {
            if (this.newFlavour && this.newFlavour.trim() !== '') {
                this.flavours.push({
                    name: this.newFlavour.trim(),
                    isVisible: this.newFlavourIsVisible,
                });
            }
            this.newFlavour = '';
            this.newFlavourIsVisible = true;
            this.isNewFlavour = false;
        },
        eraseFlavour(flavour) {
            const index = this.flavours.indexOf(flavour);
            if (index !== -1) {
                this.flavours.splice(index, 1);
            }
            if (this.flavours.length == 0) {
                this.flavourAmount = 1
            }
        },
        substractAmount() {
            if (this.flavourAmount > 1) this.flavourAmount -= 1
        },
        addAmount() {
            this.flavourAmount += 1
        },
        addNewAddon() {
            this.isNewAddon = true;
            this.$nextTick(() => {
                this.$refs.inputFieldAddon.focus();
            });
        },
        handleNewAddon() {
            if (this.newAddon !== '' && this.newAddonPrice) {
                this.newAddonPrice = this.newAddonPrice.replace(',', '.');
                const newAddonObject = {
                    name: this.newAddon,
                    price: this.newAddonPrice
                };
                this.addons.push(newAddonObject);
                this.newAddon = '';
                this.newAddonPrice = '';
                this.isNewAddon = false
            } else if (this.newAddon !== '') {
                this.$refs.inputFieldAddonPrice.focus();
            }
            else {
                this.isNewAddon = false
            }
            this.sortAddons()
        },
        sortAddons(){
            this.addons.sort((a, b) => {
                if (a.name === b.name) {
                    return a.price - b.price
                }
                return a.name.localeCompare(b.name)
            })
        },
        eraseAddon(addon) {
            const index = this.addons.indexOf(addon);
            if (index !== -1) {
                this.addons.splice(index, 1);
            }
        },
        sortItems(items) {
            items.sort((a, b) => (a.name > b.name) ? 1 : -1);
        },
        onlyNumbers(event) {
            const charCode = (event.which) ? event.which : event.keyCode;
            const inputValue = event.target.value;

            // Allow digits, dot (.) and comma (,)
            if (charCode === 46 || charCode === 44 || (charCode >= 48 && charCode <= 57)) {
                // If dot or comma already exists, prevent additional input
                if ((charCode === 46 || charCode === 44) && inputValue.includes('.') || (charCode === 46 || charCode === 44) && inputValue.includes(',')) {
                    event.preventDefault();
                    return;
                }
            } else {
                event.preventDefault();
                return;
            }

            // Replace non-numeric characters except dot (.) and comma (,)
            event.target.value = inputValue.replace(/[^0-9.,]/g, '');
        },
        submit() {
            this.checkEditedCategories()
            this.isSubmitted = true
            const isCompleted = this.checkValidators()
            this.createDishObject()
            if (isCompleted) {
                this.$nextTick(() => {
                    this.$bvModal.show('dishPreview')
                })
            }
        },
        remainingCharacters(maxLength, value) {
            return maxLength - value.length;
        },
        handleDiscountClass(personalizedDiscount) {
            const isSelected = this.selectedDiscount === personalizedDiscount && personalizedDiscount;
            const isInDiscounts = this.discounts.some(item => item.toString() === personalizedDiscount);
            return isSelected && !isInDiscounts ? 'selected-btn' : 'not-selected-btn';
        },
        showDeleteModal(category, event) {
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            this.categoryToDelete = category;
            this.$bvModal.show('deleteCategoryModal');
        },
        confirmEraseCategory() {
            this.eraseCategory(this.categoryToDelete);
            this.$bvModal.hide('deleteCategoryModal');
        },
        formatCategoryName(name) {
            return name.split(' ').map(word => {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            }).join(' ');
        }
    },
}
</script>

<template>
    <Layout>
        <UploadImage @cropedImage="onFileChange"></UploadImage>
        <Toast v-if="errorImage" :isSuccess="false" title="Umm... Algo salió mal" description="La imagen supera los 10mb"
            button="Cerrar" @close="errorImage = false" />
        <Toast v-if="isErrorDish" :isSuccess="false" title="Umm... Algo salió mal"
            description="Tuvimos problemas para publicar tu plato. Por favor, revisá la información del plato y volvé a intentarlo."
            button="Editar mi plato" @close="isErrorDish = false" />
        <Toast v-if="isSuccessDish" :isSuccess="true" title="Publicaste un nuevo plato"
            description="¡Excelente! Ahora a mezclar los ingredientes y afilar los cuchillos. Preparate para recibir nuevos pedidos."
            button="Ir a mis platos" @close="goToDishes()" />
        <div class="create-dish-back">
            <router-link to="/welly/my-dishes"><img src="@/assets/images/arrow-back.svg" alt="go back"></router-link>
            <h3>Agregar un plato</h3>
        </div>
        <form class="create-dish" @submit.prevent="submit()">
            <div class="create-dish-body">
                <div>
                    <h4>Nombre del plato</h4>
                    <h5>¡Creatividad a full!</h5>
                    <div class="create-dish-input">
                        <input :disabled="!canEditDish()" v-model="name" type="text" placeholder="Con este nombre vas a vender tu plato" maxlength="50" @keydown.enter.prevent/>
                        <p>Máx. {{ remainingCharacters(50, name) }} caracteres</p>
                        <p v-if="!name && isSubmitted" class="create-dish-error">*El nombre del plato es obligatorio.</p>
                    </div>

                    <h4>Precio</h4>
                    <h5>Indicá el valor de tu plato</h5>
                    <div style="position: relative;">
                        
                        <div class="create-dish-input--price" @mouseenter="showPriceTooltipPrice = true" @mouseleave="showPriceTooltipPrice = false">
                            <div style="position: relative; top: -2rem; left: 20rem;">
                                <PermissionTooltip :show="showPriceTooltipPrice && !canChangePrice()" />
                            </div>
                            <input :disabled="!canChangePrice()" v-model="price" type="number" step="0.01" min="0"  placeholder="$120,00" lang="es" @keydown.enter.prevent @input="formatPriceInput" @blur="formatPriceInput">
                            <p v-if="(price === '' || price === null || isNaN(Number(price)) || Number(price) < 0) && isSubmitted" class="create-dish-error">*El precio del plato es obligatorio y debe ser mayor o igual a 0.</p>                        </div>
                    </div>

                    <h4>Descripción de tu plato</h4>
                    <h5>Contá que tiene esta preparación</h5>
                    <div class="create-dish-input">
                        <textarea :disabled="!canEditDish()" v-model="description" type="text"
                            placeholder="Acá van datos importantes como los ingredientes y la forma de cocción. ¡Con todos los detalles!"
                            maxlength="160" @keydown.enter.prevent></textarea>
                        <p>Máx. {{ remainingCharacters(160, description) }} caracteres</p>
                        <p v-if="!description && isSubmitted" class="create-dish-error">*La descripción del plato es
                            obligatoria.</p>
                    </div>

                    <h4>Categoría</h4>
                    <h5>Podés elegir más de una</h5>
                    <div class="create-dish-types">
                        <b-button
                        :disabled="!canEditDish()"
                        :class="veggie ? 'selected-btn' : 'not-selected-btn'"
                        pill
                        variant="success"
                        size="lg"
                        class="type-btn"
                        @click="veggie = !veggie"
                        >
                        <VeggieIcon class="icon" />
                        Vegetariano
                        </b-button>

                        <b-button
                        :disabled="!canEditDish()"
                        :class="vegan ? 'selected-btn' : 'not-selected-btn'"
                        pill
                        variant="success"
                        size="lg"
                        class="type-btn"
                        @click="vegan = !vegan"
                        >
                        <VeganIcon class="icon" />
                        Vegano
                        </b-button>

                        <b-button
                        :disabled="!canEditDish()"
                        :class="healthy ? 'selected-btn-keto' : 'not-selected-btn-keto'"
                        pill
                        variant="success"
                        size="lg"
                        class="type-btn"
                        @click="healthy = !healthy"
                        >
                        <KetoIcon class="icon" />
                        Saludable
                        </b-button>

                        <b-button
                        :disabled="!canEditDish()"
                        :class="glutenFree ? 'selected-btn' : 'not-selected-btn'"
                        pill
                        variant="success"
                        size="lg"
                        class="type-btn"
                        @click="glutenFree = !glutenFree"
                        >
                        <GlutenFreeIcon class="icon" />
                        Sin gluten
                        </b-button>

                        <div v-if="glutenFree" class="without-tacc-container">
                            <div class="title">
                                <img src="@/assets/images/sin-tacc-icon.svg" alt height="22" />
                                <h1>Contaminación cruzada</h1>
                            </div>
                            
                            <p>¿Este alimento es apto para personas celíacas?</p>

                            <div class="checkbox-container">
                                <p>Apto celíaco</p>
                                <input type="checkbox" v-model="isCeliac">
                            </div>

                            <p><span>*</span> Al aceptar, tu plato entrará en un proceso de revisión de 24hs por parte de nuestro equipo para confirmar que cumples con los  requisitos </p>
                        </div>
                    </div>

                    <p v-if="!vegan && !glutenFree && !veggie && isSubmitted" class="create-dish-error">*Elegí al menos una
                        categoría.</p>

                    <div class="food-container">
                    <h4>Comida</h4>
                    <h5>Selecciona a que tipo de comida pertenece el plato o alimento.</h5>
                    <p>*Si no se selecciona ningún tipo, el plato o alimento será designado a "otros".</p>
                    <div class="categories-container">
                    <input :disabled="!canChangeCategory()"  class="newElement" v-if="isNewCategory" v-model="newCategory" type="text"
                            placeholder="Nueva categoría" ref="inputFieldCategory" @keyup.enter="handleNewCategory" @keydown.enter.prevent @blur="handleNewCategory">
                    <div :disabled="!canChangeCategory()" v-for="(category, index) in categories" :key="index">
                        <div 
                            v-if="category.name !== 'OTHERS'" 
                            class="category-container"
                            @mouseenter="showEraseButtonC = index" 
                            @mouseleave="showEraseButtonC = null"
                        >    
                            <div 
                            :disabled="!canChangeCategory()" 
                            class="newElement" 
                            @click="toggleSelectedCategory(category)"
                            :class="isCategorySelected(category) ? 'category-selected' : ''"
                            >
                            <input 
                                :disabled="!canChangeCategory()" 
                                type="text" 
                                v-model="editedCategories[index]" 
                                :placeholder="formatCategoryName(category.name)"
                                @keyup.enter="editCategory(category, editedCategories[index])"
                                @keydown.enter.prevent
                            />

                            <button 
                                v-if="showEraseButtonC === index || isMobile" 
                                class="delete-btn-category" 
                                :style="{ opacity: !canDeleteCategory() ? '0' : '1' }"
                                @click.stop="showDeleteModal(category, $event)"
                            >
                                X
                            </button>
                            </div>
                        </div>
                    </div>
                    </div>
                    <button :style="{'opacity': canUpdateCategory() ? '1' : '0.5'}" :disabled="!canUpdateCategory()" class="btn-add btn-grey"  v-on:click="addNewCategory()" type="button">+ Agregar nueva categoría</button>
                    <b-modal id="deleteCategoryModal" centered size="lg" hide-footer="true" v-if="canDeleteCategory()">
                        <div class="delete-category">
                            <img src="@/assets/images/delete.svg" alt="delete">
                            <h2>¿Eliminar esta categoría?</h2>
                            <p>Si eliminas esta categoría, todos los platos asignados a ella serán eliminados.</p>
                        </div>
                        <div class="btn-delete-container">
                            <b-button href="#" type="submit" variant="success" class="btn-delete btn-cancel" @click="$bvModal.hide('deleteCategoryModal')">
                            Cancelar
                            </b-button>
                            <b-button href="#" type="submit" variant="success" class="btn-delete" @click="confirmEraseCategory()">
                            Sí, eliminar
                            </b-button>
                        </div>
                    </b-modal>
                </div>
                    <h4>Agregá gustos o sabores <span class="optional">(Opcional)</span></h4>
                    <h5>Para platos que tengan variedad en sus ingredientes (por ejemplo potes de helado o empanadas). </h5>
                    <div  v-if="isNewFlavour || flavours.length != 0" class="categories-container-dishes">

                        <!--  Nuevo sabor -->
                          <div class="newElementListContainer" v-if="isNewFlavour">
                          <div class="newElementList"  @keydown.enter.prevent autofocus @keyup.enter="handleNewFlavour" v-if="isNewFlavour">
                            <div class="flavour-name-sizer" :data-value="newFlavour || 'Nuevo sabor'">
                                <textarea :disabled="!canFlavor()" class="newElement" v-if="isNewFlavour" v-model="newFlavour" rows="1"
                                placeholder="Nuevo sabor" ref="inputFieldFlavour" @blur="handleNewFlavour"></textarea>
                            </div>

                            <div class="dishes-is-active" v-if="isNewFlavour" @mousedown.prevent>
                                <div class="form-check form-switch form-switch-lg">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        :disabled="!canFlavor()"
                                        v-model="newFlavourIsVisible">
                                </div>
                            </div>
                        </div>
                        </div>

                        <!--  Lista de sabores -->
                        <div :disabled="!canFlavor()" class="flavourElement" v-for="(flavour, index) in filteredFlavours" :key="index"
                            @mouseenter="showEraseButtonF = index" @mouseleave="handleMouseLeave">
                            <div :style="{'opacity': canFlavor() ? '1' : '0.5'}" v-show="showEraseButtonF === index || isMobile" class="eraseButton" @click="eraseFlavour(flavour)">x
                            </div>
                            <div class="flavour-name-sizer" :data-value="flavour.name">
                                <textarea :style="{'opacity': canFlavor() ? '1' : '0.5'}" :disabled="!canFlavor()" rows="1" v-model="flavour.name" :placeholder="flavour.name" @mouseenter="showEraseButtonF = index"></textarea>
                            </div>
                            <div class="dishes-is-active" @mouseenter="showEraseButtonF = index">
                                <div class="form-check form-switch form-switch-lg">
                                    <input
                                        class="form-check-input"
                                        type="checkbox"
                                        :disabled="!canFlavor()"
                                        v-model="flavour.isVisible">
                                </div>
                            </div>
                        </div>
                    </div>
                    <button :style="{ 'opacity': canFlavor() ? '1' : '0.5' }" :disabled="!canFlavor()" class="btn-add" type="button" v-on:click="addNewFlavour()">+ Agregar sabor</button>

                    <div v-if="flavours.length > 0">
                        <h4>Limite de gustos o sabores</h4>
                        <h5>Indicá la cantidad máxima que pueden elegir (por ejemplo hasta 4 sabores de helado).</h5>
                        <div class="amount-setting">
                            <div :disabled="!canFlavor()" :style="{ 'opacity': canFlavor() ? '1' : '0.5' }" @click="canFlavor() && substractAmount()" class="amount" :class="flavourAmount > 1 ? 'amount-less' : ''">-
                            </div>
                            <div :disabled="!canFlavor()" :style="{ 'opacity': canFlavor() ? '1' : '0.5' }" class="amount">{{ flavourAmount }}</div>
                            <div :disabled="!canFlavor()" :style="{ 'opacity': canFlavor() ? '1' : '0.5' }" @click="canFlavor() && addAmount()" class="amount amount-more">+</div>
                        </div>
                    </div>

                    <div class="addons">
                        <h4>Agregá extras al plato <span class="optional">(Opcional)</span></h4>
                        <h5>Para que tus clientes puedan incluir otros ingredientes a la preparación original (por ejemplo
                            cebolla a una hamburguesa o adherezos a un wrap).</h5>
                        <div v-if="isNewAddon || addons.length != 0">
                            <div v-if="isNewAddon" class="addon-container">
                                <input :disabled="!canAddon()" class="newElement" v-model="newAddon" type="text" placeholder="Nuevo extra"
                                    ref="inputFieldAddon" @keyup.enter="handleNewAddon" @keydown.enter.prevent
                                    @blur="handleNewAddon" autofocus>
                                <input :disabled="!canAddon()" class="newElement addonPrice" v-model="newAddonPrice" type="text"
                                    placeholder="Precio" ref="inputFieldAddonPrice" @keyup.enter="handleNewAddon"
                                    @keydown.enter.prevent @blur="handleNewAddon" autofocus @keypress="onlyNumbers">
                            </div>
                            <div class="addon-container" v-for="(addon, index) in addons" :key="index"
                                @mouseenter="showEraseButtonA = index" @mouseleave="showEraseButtonA = null">
                                <div class="newElement" :class="showEraseButtonA == index ? 'newElementHover' : ''">
                                    <input :disabled="!canAddon()" type="text" v-model="addons[index].name" :placeholder="addon.name">
                                </div>
                                <div class="newElement addonPrice"
                                    :class="showEraseButtonA == index ? 'newElementHover' : ''">
                                    <div v-show="showEraseButtonA == index" class="eraseButton" @click="eraseAddon(addon)">x
                                    </div>
                                    <input :disabled="!canAddon()" type="text" v-model="addons[index].price" :placeholder="addon.price">
                                </div>
                            </div>
                        </div>
                        <button :disabled="!canAddon()" :style="{ 'opacity': canAddon() ? '1' : '0.5' }" class="btn-add" type="button" v-on:click="addNewAddon()"
                            :class="isNewAddon || addons.length != 0 ? 'lessMargin' : ''">+ Agregar extra</button>
                        <p v-if="isNewAddon || addons.length != 0">*El usuario podrá seleccionar 1 unidad por cada
                            ingrediente extra que agregues.</p>
                    </div>

                    <h4>Descuentos</h4>
                    <h5>Aplicá un descuento para atraer más clientes. Podrás editar esta opción más adelante.</h5>
                    <div class="create-dish-discounts" @mouseenter="showDiscountTooltip = true" @mouseleave="showDiscountTooltip = false">
                        <div style="position: relative; left: 130%;"  v-if="!canDiscountDish()">
                            <PermissionTooltip :show="showDiscountTooltip && !canDiscountDish()" />
                        </div>
                        <b-button :disabled="!canDiscountDish()" v-bind:class="!selectedDiscount ? 'selected-btn' : 'not-selected-btn'" pill
                            variant="success" size="lg" class="discount-btn" v-on:click="selectedDiscount = null">
                            SIN DCTO
                        </b-button>
                        <div v-for="(discount, index) in discounts" :key="index">
                            <b-button :disabled="!canDiscountDish()" v-bind:class="selectedDiscount == discount ? 'selected-btn' : 'not-selected-btn'" pill
                                variant="success" size="lg" class="discount-btn" v-on:click="selectedDiscount = discount">
                                {{ discount }}%
                            </b-button>
                        </div>
                        <b-button :disabled="!canDiscountDish()" v-bind:class="handleDiscountClass(personalizedDiscount)" pill variant="success" size="lg"
                            class="discount-btn" v-on:click="selectedDiscount = personalizedDiscount"
                            @change="selectedDiscount = personalizedDiscount">
                            <input type="number" v-model="personalizedDiscount" :placeholder="personalizedDiscount" min="0"
                                max="100">
                            %
                        </b-button>
                    </div>
                </div>
                <div class="create-dish-image" @mouseenter="showImageTooltipImage = true" @mouseleave="showImageTooltipImage = false">
                    <div v-show="placeholderImg" class="placeholderImg"
                        @click="() => { canImage() && this.$bvModal.show('isUploadImage') }">
                    </div>
                    <div v-show="!placeholderImg" class="newImg-container"
                        @click="() => { canImage() && this.$bvModal.show('isUploadImage') }">
                        <div :style="{ 'background-image': `url(${imgSrc})` }" class="newImg">
                        </div>
                    </div>
                    <div style="position: relative; top: 3rem;" v-if="!canImage()">
                        <PermissionTooltip :show="showImageTooltipImage && !canImage()" />
                    </div>
                    <p><span>¡Lucí tu plato!</span> Elegí una foto en
                        <span>formato horizontal</span>. El tamaño máximo es 10 mb.
                    </p>
                </div>
            </div>
            <div class="create-dish-btn-container">
                <button :style="{ 'display': canEditDish() ? 'block' : 'none' }" type='submit'>
                    Ir a la vista previa
                </button>
            </div>
        </form>
        <DishPreview v-if="this.isSubmitted" :dish="dish" @dish-toast="(value) => showDishToast(value)" />
    </Layout>
</template>

<style lang="scss" scoped>
@import "@/design/settings";
@import '@/design/views/my-dishes/createDish';
</style>
